import { useQuery } from "@tanstack/react-query";
import { getCoupons } from "../../api/apiCoupons";
import i18next from "i18next";

export const useGetCoupons = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["coupons", params, i18next.language],
        queryFn: () => getCoupons(params),
        keepPreviousData: true,
    });

    const coupons = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, coupons, meta, refetch };
};
